'use client';

import { lazy, Suspense } from 'react';
import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';

// Keep the public schema/type contract without importing checkout's client graph.
export { createOrderSchema } from '@/lib/cart-order-schema';
export type { CreateOrderFormValues } from '@/lib/cart-order-schema';

const CartPageClient = lazy(() => import('@/components/cart/cart-page-client'));

export default function CartPage() {
  return (
    <Suspense fallback={<GenericLoader />}>
      <CartPageClient />
    </Suspense>
  );
}
